import React, { useContext, useEffect, useState } from 'react'
import Row from '../../atoms/Row/Row'
import { requestMaker } from '../../../helpers/requestMaker'
import { SimpleAuthContext } from '../../../helpers/SimpleAuthProvider'
import LeaveForm from '../LeaveForm/LeaveForm'
import BaseForm from '../BaseForm/BaseForm'
import { useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { requestAccessToken } from '../../../helpers/requestAccessToken'
import Colors from '../../../assets/Color'
import GridSingles from '../../atoms/Grid/GridSingles'
import Grid from '../../atoms/Grid/Grid'
import InputText from '../../molecules/Input/InputText'
import InputTextArea from '../../molecules/InputTextArea/InputTextArea'
import formatDate from '../../../helpers/formatters'
import Attachment from '../../molecules/Attachment/Attachment'
import { updateFormVals } from '../../../helpers/update'
import {
  stepIndicatorsProps,
  isCompleted,
  isFurtherInfoStep,
  isStep,
} from '../../../helpers/formFunctions'
import DecisionMaker from '../../../assets/DecisionMaker'
import FormButtons from '../FormButtons/FormButtons'
import FormButtonsWithOverride from "../FormButtons/FormButtonsWithOverride";


const LeaveExisting = ({ id }) => {
  const [update, setUpdate] = useState('init')
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [dataFetch, setDataFetch] = useState()
  const [modalMessage, setModalMessage] = useState('initial')
  const [isLoading, setIsLoading] = useState(false)
  const [formVals, setFormVals] = useState()
  const [errors, setErrors] = useState('') 
  const [dataFromFetch, setDataFromFetch] = useState({});
  const [showAdmin, setShowAdmin] = useState(false);

  const navigate = useNavigate()
  const { instance, accounts } = useMsal()
  var { user } = useContext(SimpleAuthContext)

  useEffect(() => {
    const fetchData = async () => {
      const data = await requestMaker(
        user,
        "GET",
        "User/GetUserRole",
        localStorage.getItem("token")
      );
      if (data) {
        setShowAdmin(true);
      }
      setDataFromFetch(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!dataFetch) return
    var vals = { ...dataFetch.data }
    vals.createdAt = dataFetch.createdAt
    vals.initiatorEmail = dataFetch.initiator.email
    setFormVals(vals)
  }, [dataFetch])

  useEffect(() => {
    let token = localStorage.getItem('token')
    if (!token) {
      requestAccessToken(instance, accounts)
      token = localStorage.getItem('token')
    }
    async function fetcher() {
      setIsLoading(true)
      const dataFromRequest = await requestMaker(
        user,
        'GET',
        `process/${id}`,
        token,
      )

      setIsLoading(false)
      if (dataFromRequest?.errorMessage === 'error') {
        setModalIsOpen(true)
        setModalMessage(dataFromRequest?.result?.message)
      }
      if (!dataFromRequest) navigate('/')
      setDataFetch(dataFromRequest)
    }
    fetcher()
  }, [navigate, id, /*accounts, Put back when using MSAL */ instance])

  useEffect(() => {
    if (update == 'init')
      return

    updateFormVals(update, formVals, setFormVals)
  }, [update])

  const removeExistingAttachment = (props) => {
    let attachmentId = props.target.id

    //Ta bort den som ska bort
    let attachmentsObj = dataFetch.attachments.filter(
      (attachment) => !attachment.filename.endsWith('@' + attachmentId),
    )
    //Uppdatera state
    setDataFetch({ ...dataFetch, attachments: attachmentsObj })
  }

  return (
    <BaseForm
      modalIsOpen={modalIsOpen}
      modalMessage={modalMessage}
      stepIndicatorsProps={stepIndicatorsProps(dataFetch)}
      isLoading={isLoading}
      setModalIsOpen={setModalIsOpen}
    >
      {dataFetch && formVals && (
        <>
          <LeaveForm
            formVals={formVals}
            setFormVals={setFormVals}
            errors={errors}
            setErrors={setErrors}
            disabled={!((isFurtherInfoStep(dataFetch) || dataFetch.isDraft) && dataFetch.isAuthorized)}
          />
          <Grid>
            {(stepIndicatorsProps.currentStep === 1 ||
              isFurtherInfoStep(dataFetch) ||
              dataFetch.isDraft ||
              dataFetch.attachments.length > 0) && (
                <Attachment
                  inputId='leaveApplicationAttachment'
                  processId={dataFetch.id}
                  attachments={dataFetch.attachments}
                  allowRemove={
                    stepIndicatorsProps.currentStep === 1 ||
                    isFurtherInfoStep(dataFetch) ||
                    dataFetch.isDraft
                  }
                  handleRemoveExistingAttachment={removeExistingAttachment}
                />
              )}
            <InputText
              id={'todaysDate'}
              label={'Datum'}
              text={formatDate(dataFetch.createdAt)}
            />
          </Grid>
          <GridSingles title={'Kommentarer'}>
            <InputTextArea
              id={'lineManagerComment'}
              title={'Chef kommentar'}
              onChange={(e) => setUpdate({ id: "lineManagerComment", value: e })}
              text={formVals.lineManagerComment}
              disabled={!(isStep(dataFetch, DecisionMaker.MANAGER) && dataFetch.isAuthorized)}
            />
            <InputTextArea
              id={'hrComment'}
              title={'HR kommentar'}
              onChange={(e) => setUpdate({ id: "hrComment", value: e })}
              text={formVals.hrComment}
              disabled={!(isStep(dataFetch, DecisionMaker.HR) && dataFetch.isAuthorized)}
            />
            <InputTextArea
              id={'payrollComment'}
              title={'Payroll kommentar'}
              onChange={(e) => setUpdate({ id: "payrollComment", value: e })}
              text={formVals.payrollComment}
              disabled={!(isStep(dataFetch, DecisionMaker.PAYROLL) && dataFetch.isAuthorized)}
            />
          </GridSingles>
          <Grid title={'Underskrift'}>
            <InputText
              id={'managerSignature'}
              label={'Underskrift av chef'}
              text={formVals.managerSignature}
            />
            <InputText
              id={'managerSignatureDate'}
              label={'Underskrift datum'}
              text={formatDate(formVals.managerSignatureDate)}
            />
            <InputText
              id={'hrSignature'}
              label={'Underskrift av HR'}
              text={formVals.hrSignature}
            />
            <InputText
              id={'hrSignatureDate'}
              label={'Underskrift datum'}
              text={formatDate(formVals.hrSignatureDate)}
            />
            <InputText
              id={'payrollSignature'}
              label={'Underskrift av payroll'}
              text={formVals.payrollSignature}
            />
            <InputText
              id={'payrollSignatureDate'}
              label={'Underskrift datum'}
              text={formatDate(formVals.payrollSignatureDate)}
            />
          </Grid>

          {!isCompleted(dataFetch) &&
            dataFetch.isAuthorized &&
            (showAdmin && isStep(dataFetch, DecisionMaker.MANAGER) ? (
              <FormButtonsWithOverride
                dataFetch={dataFetch}
                user={user}
                formVals={formVals}
                setFormVals={setFormVals}
                setModalIsOpen={setModalIsOpen}
                setModalMessage={setModalMessage}
                setIsLoading={setIsLoading}
                errors={errors}
                id={id}
              />
            ) : (
              <FormButtons
                dataFetch={dataFetch}
                user={user}
                formVals={formVals}
                setFormVals={setFormVals}
                setModalIsOpen={setModalIsOpen}
                setModalMessage={setModalMessage}
                setIsLoading={setIsLoading}
                errors={errors}
                id={id}
              />
            ))}

{isCompleted(dataFetch) && (
  <Row>
    <h4 style={{ color: Colors.RED }}>
      {dataFetch?.processDecision?.isDeclined ? (
        <>
          Processen är nekad
          <br />
          {`Kommentar för avslag: ${dataFetch?.decisions[dataFetch?.decisions.length - 1].comment}`}
        </>
      ) : (
        dataFetch?.processDecision?.isFinished && 'Processen är klar'
      )}
    </h4>
  </Row>
)}
        </>
      )
      }
    </BaseForm>
  )
}

export default LeaveExisting
